var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"h-a-icon-hosting-status",class:`h-status-${_vm.status}`},[_c('i',{class:_vm.getIconClasses})])
}
var staticRenderFns = []

export { render, staticRenderFns }